// Wallet set buy box (sections/skullette-wallet-clearance.liquid), port of Afroyla's buy box v3:
//   1) tier rows 3 / 6 / 9 = pay for 1 / 2 / 3; tier price = data-tiers, which MUST equal the Function gate wallet-clear;
//   2) style tabs + form filter (all · long · mini) + a grid with a stepper per tile (Add → − n +) and a detail sheet;
//      the slot strip shows the set so far (tap a filled slot to remove that unit).
// Pricing mirrors the Function (set_free_count + paid-unit cap): the priciest paid[tier] units pay, the rest are $0,
// and the paid units never cost more than the tier price, so the page never prints a number the cart will not.
const root = document.querySelector('[data-skc][data-skc-kind="wallet"]');
if (root && window.fetch) {
  const core = await import(root.getAttribute('data-skc-core'));
  init(core);
}

function init({ money, fill, esc, decodeEntities, onCartChange, readJson, scrollToEl, addSetToCart, paintDeadline, renderTabs, createSheet, paintSheetGallery, wireSticky }) {
  const C = readJson(root, '[data-skc-copy]', {});
  const pool = readJson(root, '[data-skc-pool="wallet"]', []);
  let TIERS = {};
  try {
    TIERS = JSON.parse(root.getAttribute('data-tiers') || '{}');
  } catch (error) {
    console.error('[skc] tiers_json is not JSON', error);
  }
  const TIER_KEYS = Object.keys(TIERS).map(Number).filter((n) => n > 0 && n % 3 === 0).sort((a, b) => a - b);
  if (!pool.length || !TIER_KEYS.length) {
    console.error('[skc] wallet set: empty pool or tiers; buy box disabled');
    return;
  }
  const PAGE = 8;
  const EL = 'x-wc';
  const WORDS = (C.paid_words || 'one,two,three').split(',').map((w) => w.trim());
  const listUnit = Math.max(...pool.map((p) => p.v.p)); // empty slots read as the priciest wallet
  const TABS = (root.getAttribute('data-tabs') || '').split('|').map((x) => x.split('=')).filter((x) => x[0] && x[1]).map(([key, label]) => ({ key: key.trim(), label: label.trim() }));

  const st = { tier: TIER_KEYS[0], form: 'all', tab: null, picks: [], shown: PAGE, busy: false, cartUnits: [] /* cents of wallet-clear units already in the cart */ };
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => root.querySelectorAll(sel);
  const setText = (sel, txt) => $$(sel).forEach((el) => (el.textContent = txt));
  const paidN = () => st.tier / 3;
  const full = () => st.picks.length >= st.tier;
  const count = (p) => st.picks.filter((x) => x === p).length;
  // per-design cap = in-pool stock, at most 9 (pool entry "m"): the stepper stops before /cart/add.js would 422
  const capped = (p) => count(p) >= (p.v.m || 9);
  const canAdd = (p) => !full() && !capped(p);

  const formOk = (p) => st.form === 'all' || p.fm === st.form;
  const tabs = () => {
    const items = pool.filter(formOk);
    const have = new Set(items.map((x) => x.s));
    const out = TABS.filter((t) => have.has(t.key));
    if ([...have].some((s) => !TABS.some((t) => t.key === s))) out.push({ key: 'other', label: C.tab_other || 'More' });
    return out;
  };
  const inTab = (p, tab) => (tab === 'other' ? !TABS.some((t) => t.key === p.s) : p.s === tab);
  const curTab = () => {
    const t = tabs();
    if (!t.some((x) => x.key === st.tab)) st.tab = t[0]?.key;
    return st.tab;
  };

  // ad hand-off (#745): snippets/skullette-ad-design-hero read the URL and tagged the root with the design the ad showed
  // (+ its variant when the link carried one). That wallet is the first of her three: its style tab, kept on screen.
  (function prepick() {
    const key = root.getAttribute('data-sk-ad-design');
    if (!key) return;
    const vid = Number(root.getAttribute('data-sk-ad-variant')) || 0;
    const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const mine = pool.filter((p) => slug(p.d) === key);
    const p = mine.find((x) => Number(x.v.id) === vid) || mine.find((x) => x.fm === 'wallet') || mine[0];
    if (!p) return;
    st.picks.push(p);
    st.tab = TABS.some((t) => t.key === p.s) ? p.s : 'other';
    const at = pool.filter((x) => formOk(x) && inTab(x, st.tab)).indexOf(p);
    if (at >= st.shown) st.shown = at + 1;
  })();

  /* ---- pricing = the Function's own rule (afl-set-discount v7, set-free-count-sets.js cheapestSplit) ----
   * All wallet-clear units in the cart (priciest first) are split into consecutive sets of 3 / 6 / 9 so the customer
   * pays least; in each set the priciest size/3 units pay, capped at the tier price; units outside any set pay list.
   * Integer cents, same as the Function. The page prints what THIS add changes at checkout:
   * cost(units already in the cart + this set) − cost(units already in the cart), so repeat adds read right too. */
  const SPLIT_TIERS = TIER_KEYS.slice().sort((a, b) => b - a).map((size) => ({ size, paid: size / 3, cap: Math.round(TIERS[size] * 100) }));
  function cheapestSplit(prices) {
    const n = prices.length;
    const pre = [0];
    for (let i = 0; i < n; i += 1) pre.push(pre[i] + prices[i]);
    const best = [0];
    const pick = [0];
    for (let s = 1; s <= n; s += 1) {
      best[s] = -1;
      for (const t of SPLIT_TIERS) {
        const start = s - t.size;
        if (start < 0 || best[start] < 0) continue;
        const paid = pre[start + t.paid] - pre[start];
        const cost = best[start] + (t.cap > 0 && t.cap < paid ? t.cap : paid);
        if (best[s] < 0 || cost < best[s]) {
          best[s] = cost;
          pick[s] = t.size;
        }
      }
    }
    let cover = 0;
    let total = pre[n];
    for (let s = n; s > 0; s -= 1) {
      if (best[s] < 0) continue;
      const tot = best[s] + pre[n] - pre[s];
      if (tot < total) {
        total = tot;
        cover = s;
      }
    }
    const sizes = [];
    for (let s = cover; s > 0; s -= pick[s]) sizes.unshift(pick[s]);
    return { sizes, total };
  }
  const cents = (dollars) => Math.round(dollars * 100);
  const costOf = (unitCents) => cheapestSplit(unitCents.slice().sort((a, b) => b - a)).total;
  /** what adding `unitCents` changes at checkout, given the wallet-clear units already in the cart */
  const deltaCents = (unitCents) => costOf(st.cartUnits.concat(unitCents)) - costOf(st.cartUnits);

  function pricing() {
    // slots: the picks, then empty slots valued as the priciest wallet (the number before the set is complete)
    const slots = st.picks.map((p, i) => ({ c: cents(p.v.p), i })).concat(Array.from({ length: st.tier - st.picks.length }, (_, e) => ({ c: cents(listUnit), i: st.picks.length + e })));
    const sorted = slots.slice().sort((a, b) => b.c - a.c || a.i - b.i);
    const { sizes } = cheapestSplit(sorted.map((x) => x.c));
    const paidSlots = new Set();
    let start = 0;
    sizes.forEach((size) => {
      for (let k = start; k < start + size / 3; k += 1) paidSlots.add(sorted[k].i);
      start += size;
    });
    for (let k = start; k < sorted.length; k += 1) paidSlots.add(sorted[k].i); // outside every set = pays list
    const value = slots.reduce((s, x) => s + x.c, 0) / 100;
    const pay = deltaCents(slots.map((x) => x.c)) / 100;
    return { value, pay, paidSlots, paidCount: paidSlots.size, paidIdx: [...paidSlots].filter((i) => i < st.picks.length) };
  }
  /** a tier row's price = this add's checkout delta if filled with the priciest wallet */
  const tierPrice = (n) => deltaCents(Array.from({ length: n }, () => cents(listUnit))) / 100;

  function renderTiers(pr) {
    const box = $('[data-skc-tiers]');
    box.innerHTML = '';
    TIER_KEYS.forEach((n) => {
      const t = C.tiers?.[n] || {};
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'skc__tier';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(n === st.tier));
      b.setAttribute('data-hc-el', `${EL}-tier-${n}`);
      const badge = t.badge ? ` <span class="badge${String(n) === String(C.best_tier) ? ' is-best' : ''}">${esc(t.badge)}</span>` : '';
      b.innerHTML = `<span class="rad" aria-hidden="true"></span><span class="txt"><b>${esc(t.title || n)}${badge}</b><small>${esc(fill(t.sub, { each: money(Math.round((n === st.tier ? pr.pay : tierPrice(n)) * 100 / n) / 100) }))}</small></span><span class="pr"><span class="p">${money(n === st.tier ? pr.pay : tierPrice(n))}</span></span>`;
      b.addEventListener('click', () => {
        st.tier = n;
        st.picks = st.picks.slice(0, n);
        render();
      });
      box.appendChild(b);
    });
  }

  function renderSlots(pr) {
    const box = $('[data-skc-slots]');
    box.innerHTML = '';
    for (let i = 0; i < st.tier; i += 1) {
      const p = st.picks[i];
      // filled: paid when the Function would charge it; empty: the first (paid count still open) empties read "you pay"
      const paid = pr.paidSlots.has(i);
      const el = document.createElement(p ? 'button' : 'span');
      if (p) {
        el.type = 'button';
        el.setAttribute('aria-label', `Remove ${p.d}`);
        el.setAttribute('data-hc-el', `${EL}-slot-remove`);
        el.addEventListener('click', () => {
          st.picks.splice(i, 1);
          render();
        });
      }
      el.className = `skc__slot${p ? ' is-filled' : ''}${paid ? ' is-paid' : ' is-free'}`;
      const tag = paid ? (p ? money(p.v.p) : C.slot_pay) : C.slot_free;
      el.innerHTML = (p ? `<span class="im"><img src="${esc(p.img)}" alt=""></span><span class="x" aria-hidden="true">×</span>` : `<span class="im is-empty">${i + 1}</span>`) + `<span class="tag">${esc(tag || '')}</span>`;
      box.appendChild(el);
    }
  }

  function stepper(p, cls) {
    const c = count(p);
    const wrap = document.createElement('div');
    wrap.className = 'skc__stepper' + (cls ? ' ' + cls : '') + (c ? ' is-on' : '');
    if (!c) {
      wrap.innerHTML = `<button type="button" class="add" data-hc-el="${EL}-tile-add"${canAdd(p) ? '' : ' disabled'}>${esc(full() ? C.full : C.add)}</button>`;
      wrap.querySelector('.add').addEventListener('click', () => {
        if (!canAdd(p)) return;
        st.picks.push(p);
        render();
      });
    } else {
      wrap.innerHTML = `<button type="button" class="dec" aria-label="Remove one" data-hc-el="${EL}-tile-minus">−</button><span class="qty" aria-live="polite">${esc(fill(C.in_set, { n: c }))}</span><button type="button" class="inc" aria-label="Add one more" data-hc-el="${EL}-tile-plus"${canAdd(p) ? '' : ' disabled'}>+</button>`;
      wrap.querySelector('.dec').addEventListener('click', () => {
        const i = st.picks.lastIndexOf(p);
        if (i > -1) st.picks.splice(i, 1);
        render();
      });
      wrap.querySelector('.inc').addEventListener('click', () => {
        if (!canAdd(p)) return;
        st.picks.push(p);
        render();
      });
    }
    return wrap;
  }

  function renderGrid() {
    renderTabs($('[data-skc-tabs="wallet"]'), tabs(), curTab(), EL, (key) => {
      st.tab = key;
      st.shown = PAGE;
      render();
    });
    const grid = $('[data-skc-grid="wallet"]');
    const more = $('[data-skc-more="wallet"]');
    const list = pool.filter((p) => formOk(p) && inTab(p, curTab()));
    grid.innerHTML = '';
    list.slice(0, st.shown).forEach((p) => {
      const t = document.createElement('div');
      t.className = 'skc__tile' + (count(p) ? ' is-picked' : '');
      const form = p.fm === 'mini' ? C.form_mini : C.form_wallet;
      t.innerHTML = `<button type="button" class="skc__tile-view" data-hc-el="${EL}-tile-view" aria-label="${esc(C.view_details)}: ${esc(p.d)}"><span class="im"><img src="${esc(p.img)}" alt="" loading="lazy" width="700" height="933"></span></button><div class="skc__tile-body"><span class="n">${esc(p.d)}</span><span class="f">${esc(fill(C.tile_line, { form, price: money(p.v.p) }))}</span></div><button type="button" class="skc__tile-link" data-hc-el="${EL}-tile-view">${esc(C.view_details)}</button>`;
      t.querySelectorAll('.skc__tile-view, .skc__tile-link').forEach((b) => b.addEventListener('click', () => openSheet(p)));
      t.appendChild(stepper(p));
      grid.appendChild(t);
    });
    const left = list.length - st.shown;
    more.hidden = left <= 0;
    if (left > 0) more.textContent = fill(C.show_more, { n: left });
  }

  const cta = $('[data-skc-cta]');
  const ctaLabel = $('[data-skc-cta-label]');
  const ctaPrice = $('[data-skc-cta-price]');
  const err = $('[data-skc-error]');
  const stBtn = $('[data-skc-sticky-btn]');
  const ctaText = (left) => (left > 0 ? fill(C.cta_pick, { n: left }) : fill(C.cta_add, { n: st.tier }));

  function render() {
    const pr = pricing();
    const left = st.tier - st.picks.length;
    renderTiers(pr);
    renderSlots(pr);
    renderGrid();
    setText('[data-skc-was]', fill(C.card_was, { value: money(pr.value) }));
    setText('[data-skc-sum-was]', money(pr.value));
    setText('[data-skc-price]', money(pr.pay));
    setText('[data-skc-sum-pay]', money(pr.pay));
    setText('[data-skc-chip]', C.chip_save && pr.value - pr.pay > 0.004 ? fill(C.chip_save, { amount: money(pr.value - pr.pay) }) : '');
    setText('[data-skc-sum-label]', fill(C.sum_label, { paid: pr.paidCount, free: st.tier - pr.paidCount }));
    setText('[data-skc-count="wallet"]', fill(C.count, { c: st.picks.length, n: st.tier }));
    setText('[data-skc-slots-note]', fill(C.slots_note, { n: WORDS[pr.paidCount - 1] || pr.paidCount }));
    $$('[data-skc-form]').forEach((b) => b.setAttribute('aria-pressed', String(b.getAttribute('data-skc-form') === st.form)));
    if (!st.busy) {
      cta.disabled = !full();
      ctaLabel.textContent = ctaText(left);
      ctaPrice.textContent = full() ? money(pr.pay) : '';
      stBtn.textContent = full() ? fill(C.cta_add, { n: st.tier }) : ctaText(left) + ' ↑';
    }
    setText('[data-skc-sticky-price]', money(pr.pay));
    setText('[data-skc-sticky-sub]', fill(C.sticky_sub, { c: st.picks.length, n: st.tier }));
    if (sheet.state.open) fillSheetState();
    sticky?.refresh();
  }

  // ---- detail sheet ----
  const sheet = createSheet(root);
  let sheetP = null;
  function openSheet(p) {
    sheetP = p;
    paintSheetGallery(sheet, p.imgs?.length ? p.imgs : [p.img], p.d);
    sheet.q('[data-skc-sheet-title]').textContent = `${p.d} · ${p.fm === 'mini' ? C.form_mini : C.form_wallet}`;
    sheet.q('[data-skc-sheet-statement]').hidden = true;
    const note = sheet.q('[data-skc-sheet-note]');
    note.textContent = decodeEntities(p.note);
    note.hidden = !p.note;
    const facts = [[C.fact_size, p.sz], [C.fact_holds, p.fits], [C.fact_material, C.material], [C.fact_sold_apart, money(p.v.p)]];
    sheet.q('[data-skc-sheet-facts]').innerHTML = facts.filter((f) => f[0] && f[1]).map((f) => `<div><dt>${esc(f[0])}</dt><dd>${esc(f[1])}</dd></div>`).join('');
    sheet.q('[data-skc-sheet-link]').href = p.url;
    fillSheetState();
    sheet.open();
  }
  function fillSheetState() {
    const p = sheetP;
    if (!p) return;
    const c = count(p);
    const { paidIdx } = pricing();
    const isPaid = st.picks.some((x, i) => x === p && paidIdx.includes(i));
    const eb = sheet.q('[data-skc-sheet-eyebrow]');
    eb.textContent = c ? (isPaid ? C.sheet_paid : C.sheet_free) : full() ? C.sheet_full : st.picks.length < paidN() ? C.sheet_next_paid : C.sheet_next_free;
    eb.hidden = !eb.textContent;
    const box = sheet.q('[data-skc-sheet-actions]');
    box.innerHTML = '';
    box.appendChild(stepper(p, 'is-big'));
  }

  // ---- cart ----
  const setState = (state) => {
    const txt = state === 'busy' ? C.cta_busy : state === 'added' ? C.cta_added : fill(C.cta_add, { n: st.tier });
    ctaLabel.textContent = txt;
    stBtn.textContent = txt;
    cta.classList.toggle('is-added', state === 'added');
    cta.disabled = state !== '';
    stBtn.disabled = state !== '';
  };
  async function add() {
    if (st.busy || !full()) return;
    st.busy = true;
    setState('busy');
    err.hidden = true;
    const byId = new Map();
    st.picks.forEach((p) => byId.set(p.v.id, (byId.get(p.v.id) || 0) + 1));
    const items = [...byId].map(([id, quantity]) => ({ id: Number(id), quantity }));
    try {
      await addSetToCart(items, { key: root.getAttribute('data-key'), setName: root.getAttribute('data-set-name'), source: root.getAttribute('data-source') });
      setState('added');
      setTimeout(() => {
        st.busy = false;
        st.picks = [];
        setState('');
        render();
      }, 1800);
    } catch (error) {
      console.error('[skc] wallet set add failed', error);
      st.busy = false;
      setState('');
      render();
      err.textContent = C.error || '';
      err.hidden = false;
    }
  }

  $$('[data-skc-form]').forEach((b) =>
    b.addEventListener('click', () => {
      st.form = b.getAttribute('data-skc-form');
      st.shown = PAGE;
      render();
    })
  );
  $('[data-skc-more="wallet"]').addEventListener('click', () => {
    st.shown += PAGE * 2;
    render();
  });
  cta.addEventListener('click', add);

  // sticky bar: add when full; inside the grid (strip stuck) pulse the empty slots + hint instead of scrolling her away
  const gridTop = () => scrollToEl($('[data-skc-part="wallet"]'));
  const hint = document.createElement('p');
  hint.className = 'skc-sticky__hint';
  hint.setAttribute('aria-live', 'polite');
  hint.hidden = true;
  $('[data-skc-sticky]')?.appendChild(hint);
  let nudgeTimer;
  const nudge = (left) => {
    const b = $('[data-skc-stickybar]');
    if (b) {
      b.classList.remove('is-nudge');
      void b.offsetWidth; // restart the animation on repeat taps
      b.classList.add('is-nudge');
    }
    hint.textContent = fill(C.nudge, { n: left, s: left === 1 ? '' : 's' });
    hint.hidden = !hint.textContent;
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(() => {
      hint.hidden = true;
      b?.classList.remove('is-nudge');
    }, 2600);
  };
  stBtn.addEventListener('click', () => {
    if (full()) add();
    else if ($('[data-skc-stickybar]')?.classList.contains('is-stuck')) nudge(st.tier - st.picks.length);
    else gridTop();
  });
  $('[data-skc-back]')?.addEventListener('click', gridTop);

  // the units already in the cart change what the next set costs (v7 splits ALL wallet-clear units): keep them fresh
  const refreshCartUnits = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart) return;
        const key = root.getAttribute('data-key');
        st.cartUnits = cart.items.filter((it) => it.properties?._afl_lp === key).flatMap((it) => Array(it.quantity).fill(it.original_price));
        if (!st.busy) render();
      })
      .catch((error) => console.error('[skc] cart read failed', error));
  onCartChange(refreshCartUnits);
  refreshCartUnits();

  paintDeadline(root, C);
  const sticky = wireSticky(root, { cta, isSheetOpen: () => sheet.state.open });
  render();
}
